<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form class="astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['name']"></astral-input>
          <app-money-box [control]="form.controls['keyPrice']"></app-money-box>
          @if (currencySelection && currencySelection.length > 1) {
            <astral-select [control]="form.controls['currencyCode']" [itemsSource]="currencySelection"></astral-select>
          }
          <astral-select [control]="form.controls['vatPercentage']" [itemsSource]="vatPercentages"></astral-select>
        </astral-layout-group>
      </section>
      @for (codingForm of codingForms; track codingForm) {
        <section class="astral-section-surface astral-stack-m">
          @if (codingForms.length > 1) {
            <h4>{{ codingForm.controls['accountPlanName'].value }}</h4>
          }
          <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
            <astral-select
              [control]="codingForm.controls['incomeAccountId']"
              [itemsSource]="getIncomeAccountSelection(codingForm.controls['accountPlanId'].value)"
            ></astral-select>
          </astral-layout-group>
        </section>
      }
    </form>
  }
</section>
